import React from 'react';
import { Search, MessageCircle, Mail, FileText, Package, Wallet, RotateCcw, ShieldAlert } from 'lucide-react';
import { PageHeader, LegalLayout } from '../components/Layout';
import { GlassCard, Button } from '../components/ui';
export const SupportPage = () => {
  return <div className="min-h-screen bg-[#050810]" data-id="element-737">
      <PageHeader title="How can we help you?" description="Search our knowledge base or get in touch with our support team." data-id="element-738" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 -mt-20 relative z-20" data-id="element-739">
        {/* Search Bar */}
        <GlassCard className="p-4 mb-16 flex items-center gap-4 bg-[#0a0e27]/90" data-id="element-740">
          <Search className="w-6 h-6 text-gray-400 ml-2" data-id="element-741" />
          <input type="text" placeholder="Search for articles, issues, or keywords..." className="flex-1 bg-transparent border-none outline-none text-white text-lg placeholder:text-gray-500" data-id="element-742" />
          <Button data-id="element-743">Search</Button>
        </GlassCard>

        {/* Categories Grid */}
        <h2 className="text-2xl font-bold text-white mb-8" data-id="element-744">
          Browse Categories
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-16" data-id="element-745">
          {[{
          icon: Package,
          title: 'Order Help',
          desc: 'Track, missing items, delivery'
        }, {
          icon: Wallet,
          title: 'Wallet Issues',
          desc: 'Funding, balance, errors'
        }, {
          icon: RotateCcw,
          title: 'Refunds',
          desc: 'Request refund, status'
        }, {
          icon: ShieldAlert,
          title: 'Safety & Scams',
          desc: 'Report fraud, account security'
        }].map((cat, i) => <GlassCard key={i} className="p-6 cursor-pointer group" data-id="element-746">
              <cat.icon className="w-8 h-8 text-purple-400 mb-4 group-hover:scale-110 transition-transform" data-id="element-747" />
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-748">{cat.title}</h3>
              <p className="text-sm text-gray-400" data-id="element-749">{cat.desc}</p>
            </GlassCard>)}
        </div>

        {/* Contact Options */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-750">
          <GlassCard className="p-8 border-purple-500/20" data-id="element-751">
            <MessageCircle className="w-10 h-10 text-purple-400 mb-6" data-id="element-752" />
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-753">Live Chat</h3>
            <p className="text-gray-400 mb-6" data-id="element-754">
              Get instant help from our support agents. Available 24/7 for
              urgent issues.
            </p>
            <Button className="w-full" data-id="element-755">Start Chat</Button>
          </GlassCard>

          <GlassCard className="p-8" data-id="element-756">
            <Mail className="w-10 h-10 text-blue-400 mb-6" data-id="element-757" />
            <h3 className="text-2xl font-bold text-white mb-2" data-id="element-758">
              Email Support
            </h3>
            <p className="text-gray-400 mb-6" data-id="element-759">
              Send us a detailed message and we'll get back to you within 24
              hours.
            </p>
            <Button variant="secondary" className="w-full" data-id="element-760">
              Submit Ticket
            </Button>
          </GlassCard>
        </div>
      </div>
    </div>;
};